import { Controller, useFieldArray } from "react-hook-form";
import { Form } from "react-bootstrap";
import NumberInDecimals from "../../../../components/inputs/NumberFormatted";
import { currencySymbol } from "../../../../utils/numberFormatter";
import {
  Payable_Commission,
  isEnabled,
} from "../../../../constants/featureSettings";

export const emptyCommission = { id: null, name: "", amount: "" };

// Form "commissions" -> payload rows (id keeps the link to its expense)
export const toCommissionPayload = (commissions = []) =>
  commissions.map(({ id, name, amount }) => ({ id, name, amount }));

// API payable_commissions -> form "commissions"
export const fromCommissionData = (rows = []) =>
  rows.map((c) => ({ id: c.id, name: c.commission_name ?? "", amount: c.amount }));

// PO commissions in the selected currency.
// Info only: not included in the PO total; each becomes an expense on approval.
const CommissionList = ({ control, register, currencyName = "PHP", readOnly }) => {
  // keyName "key" so the commission's own "id" is kept in the form values
  const { fields, append, remove } = useFieldArray({
    control,
    name: "commissions",
    keyName: "key",
  });

  if (!isEnabled(Payable_Commission)) return null;

  const symbol = currencySymbol[currencyName] ?? currencyName;

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-1">
        <label>
          Commission{" "}
          <small className="text-muted">(not included in total amount)</small>
        </label>
        {!readOnly && (
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            onClick={() => append({ ...emptyCommission })}
          >
            + Add Commission
          </button>
        )}
      </div>

      {fields.length === 0 && (
        <small className="text-muted d-block">No commission</small>
      )}

      {fields.map((field, index) => (
        <div key={field.key} className="d-flex gap-2 mb-2">
          <Form.Control
            type="text"
            placeholder="Commission Name"
            className="p-2"
            maxLength={100}
            readOnly={readOnly}
            {...register(`commissions.${index}.name`)}
          />
          <div className="input-group">
            <span className="input-group-text p-2 text-secondary">{symbol}</span>
            <Controller
              name={`commissions.${index}.amount`}
              control={control}
              render={({ field: amountField }) => (
                <NumberInDecimals
                  decimals={2}
                  placeholder="0.00"
                  className="form-control p-2"
                  value={amountField.value}
                  onChange={amountField.onChange}
                  readOnly={readOnly}
                />
              )}
            />
          </div>
          {!readOnly && (
            <button
              type="button"
              className="btn btn-sm btn-outline-danger"
              onClick={() => remove(index)}
            >
              X
            </button>
          )}
        </div>
      ))}
    </div>
  );
};

export default CommissionList;
